// extracted by css-extract-rspack-plugin
export default {"editor":"w4WGe"};